export default "__VITE_ASSET__GEW2duWS__"